import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
interface iValue {label:string,value:string}
interface iProps {
 data:iValue[],name:string,
    onChange:(e:React.ChangeEvent)=>void,title:string,
    disabled?:boolean,
    value:string
}
export const MyRadioGroup =({data,title,name,onChange,disabled,value}:iProps)=>{
    return (
        <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">{title}</FormLabel>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={data[0].value}
                name={name}
                onChange={onChange}
                value={value}
                sx={{
                    '&.MuiFormGroup-root': {
                            display:'flex',
                            flexDirection:'row'
                        }
                    
                }}
            >
                {
                    data.map((ele,index)=>
                    <FormControlLabel key={index}  value={ele.value} control={<Radio disabled={disabled} sx={{fontSize:'10px'}} />} label={ele.label} />
                    )
                }
            </RadioGroup>
        </FormControl>
    )
}
